import { render, staticRenderFns } from "./BookingTalentNotificationsListItem.vue?vue&type=template&id=0a5730a8"
import script from "./BookingTalentNotificationsListItem.vue?vue&type=script&lang=js"
export * from "./BookingTalentNotificationsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports